import { Component, Inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { Estudo } from '../estudo/estudo';
import { Ocorrencia } from '../ocorrencia/ocorrencia';
import { OcorrenciaService } from '../ocorrencia/ocorrencia.service';

@Component({
  selector: 'app-desclassificar-varios-detail',
  templateUrl: './desclassificar-varios-detail.component.html',
  styleUrls: ['desclassificar-varios-detail.component.css']
})
export class DesclassificarVariosDetailComponent implements OnInit {

  isLoading = false;
  @Input() list: Estudo[];
  @Output() desclassificarEmitido: EventEmitter<Ocorrencia[]> = new EventEmitter<Ocorrencia[]>();
  justificativa: string;
  mensagemTela: string;

  constructor(
    public dialogRef: MatDialogRef<number>, public ocorrenciaService: OcorrenciaService,
    private mensagem: MatSnackBar) {
  }

  ngOnInit() {

  }

  desclassificar() {
    this.isLoading = true;

    if (this.list) {
      let contador = 1;
      this.mensagemTela = '';
      for (const estudo of this.list) {
        const ocorrencia = new Ocorrencia();
        ocorrencia.codigoEstudoSocioEconomico = estudo.id;
        ocorrencia.justificativa = this.justificativa;
        ocorrencia.desclassificarEstudo = true;

        const listaOcorrenciasSalvas = new Array<Ocorrencia>();
        this.ocorrenciaService.update(ocorrencia).subscribe(
          (result: Ocorrencia) => {
            this.mensagemTela = 'Desclassificando ' + contador + ' de ' + this.list.length + '...' ;
            contador++;
            listaOcorrenciasSalvas.push(result);
            if (contador ===  this.list.length) {
              this.desclassificarEmitido.emit(listaOcorrenciasSalvas);
              this.mensagem.open(contador + ' estudo(s) desclassificado(s).', 'X', { duration: 5000 });
              this.isLoading = false;
            }
          },
          error => this.erro(error)
        );
      }
    }
  }

  private erro(erro: string): void {
    this.mensagem.open(erro, 'X', { duration: 5000 });
    this.isLoading = false;
  }
}
